export default "__VITE_ASSET__xdMVRpA$__"